import {
  ElementListWidgetData,
  ElementListWidgetPropertyValue,
} from "src/dynamic-view-renderer/Widgets/ElementListWidget/ElementListWidget.tsx";
import { ElementList } from "src/types/elementList.ts";
import { PropertyValue } from "src/types/property.ts";

/**
 * Maps domain {@link ElementList} (already produced from GraphQL via `mapToCase`) into
 * {@link ElementListWidgetData} for the UI. Formatting of values is injected so presentation
 * stays consistent with the rest of the app (`useFormatPropertyValue`).
 */
export const mapElementListToElementListWidgetData = (
  elementList: ElementList | undefined,
  formatPropertyValue: (propertyValue: PropertyValue) => unknown
): ElementListWidgetData | undefined => {
  if (!elementList) return undefined;

  return {
    code: elementList.code,
    name: elementList.name,
    typeCode: elementList.typeCode,
    elements: elementList.elements.map((element) => ({
      id: element.id,
      name: element.name ?? "",
      properties: element.properties.map((propertyValue): ElementListWidgetPropertyValue => {
        const formattedValue = formatPropertyValue(propertyValue);

        return {
          property: {
            code: propertyValue.property.code,
            name: propertyValue.property.name,
          },
          value:
            formattedValue === null || formattedValue === undefined
              ? undefined
              : String(formattedValue),
        };
      }),
    })),
  };
};
